/**
 * Blog Single Post Features
 * Reading progress, TOC, Custom Audio player
 */

function initReadingProgress() {
    var progress = document.getElementById('reading-progress');
    if (!progress) return;

    function setReadingProgress() {
        var docHeight = document.body.scrollHeight - window.innerHeight;
        var winScroll = window.scrollY || window.pageYOffset;
        var percent = docHeight > 0 ? (winScroll / docHeight) * 100 : 0;
        if (percent < 0) percent = 0;
        if (percent > 100) percent = 100;
        progress.style.width = percent + '%';
    }

    window.addEventListener('scroll', setReadingProgress);
    window.addEventListener('resize', setReadingProgress);
    setReadingProgress();
}

function initBlogTOC() {
    var tocLinks = document.querySelectorAll('.toc-link');
    var sections = document.querySelectorAll('[id]');

    if (tocLinks.length === 0) return;

    function updateActiveLink() {
        var current = '';
        sections.forEach(function(section) {
            var sectionTop = section.offsetTop;
            var header = document.querySelector('header');
            var headerHeight = header ? header.offsetHeight : 150;
            if (pageYOffset >= (sectionTop - headerHeight - 50)) {
                current = section.getAttribute('id');
            }
        });

        tocLinks.forEach(function(link) {
            link.classList.remove('text-primary', 'font-semibold');
            if (link.getAttribute('href') === '#' + current) {
                link.classList.add('text-primary', 'font-semibold');
            }
        });
    }

    tocLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            var targetId = this.getAttribute('href').substring(1);
            var targetSection = document.getElementById(targetId);

            if (targetSection) {
                var headerOffset = 112;
                var elementPosition = targetSection.getBoundingClientRect().top;
                var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });

    window.addEventListener('scroll', updateActiveLink);
    updateActiveLink();
}

function formatAudioTime(seconds) {
    if (!Number.isFinite(seconds) || seconds < 0) {
        return '0:00';
    }

    var mins = Math.floor(seconds / 60);
    var secs = Math.floor(seconds % 60);
    return mins + ':' + String(secs).padStart(2, '0');
}

function normalizeAudioSrc(url) {
    if (!url) return url;

    try {
        var parsed = new URL(url, window.location.origin);
        if (parsed.pathname.indexOf('/wp-content/uploads/') !== -1) {
            return window.location.origin + parsed.pathname;
        }
    } catch (e) {}

    return url;
}

function initCustomAudioPlayer() {
    var playerContainer = document.querySelector('[data-custom-audio-player]');
    var audio = document.getElementById('blog-audio-player');

    if (!playerContainer || !audio) return null;

    var audioSrc = playerContainer.getAttribute('data-audio-src') || '';
    var sourceEl = audio.querySelector('source');
    var rawSrc = sourceEl ? sourceEl.getAttribute('src') : '';
    var normalizedSrc = normalizeAudioSrc(rawSrc || audioSrc);

    if (sourceEl && normalizedSrc && normalizedSrc !== rawSrc) {
        sourceEl.setAttribute('src', normalizedSrc);
        audioSrc = normalizedSrc;
        playerContainer.setAttribute('data-audio-src', normalizedSrc);
        audio.load();
    }

    var playBtn = playerContainer.querySelector('.custom-audio-play-btn');
    var playIcon = playerContainer.querySelector('.custom-audio-play-icon');
    var pauseIcon = playerContainer.querySelector('.custom-audio-pause-icon');
    var timeEl = playerContainer.querySelector('.custom-audio-time');
    var seekTrack = playerContainer.querySelector('.custom-audio-seek-track');
    var seekProgress = playerContainer.querySelector('.custom-audio-seek-progress');
    var volumeBtn = playerContainer.querySelector('.custom-audio-volume-btn');
    var volumeIcon = playerContainer.querySelector('.custom-audio-volume-icon');
    var mutedIcon = playerContainer.querySelector('.custom-audio-muted-icon');
    var downloadBtn = playerContainer.querySelector('.custom-audio-download-btn');
    var isPlaying = false;
    var isSeeking = false;

    function updateButtonState() {
        if (isPlaying) {
            playIcon.classList.add('hidden');
            pauseIcon.classList.remove('hidden');
        } else {
            playIcon.classList.remove('hidden');
            pauseIcon.classList.add('hidden');
        }
    }

    function updateVolumeState() {
        if (audio.muted) {
            volumeIcon.classList.add('hidden');
            mutedIcon.classList.remove('hidden');
        } else {
            volumeIcon.classList.remove('hidden');
            mutedIcon.classList.add('hidden');
        }
    }

    function updateTimeDisplay() {
        var current = formatAudioTime(audio.currentTime);
        var total = Number.isFinite(audio.duration) && audio.duration > 0
            ? formatAudioTime(audio.duration)
            : '0:00';
        timeEl.textContent = current + ' / ' + total;
    }

    function updateProgress() {
        updateTimeDisplay();

        if (isSeeking || !Number.isFinite(audio.duration) || audio.duration <= 0) {
            return;
        }

        var percent = (audio.currentTime / audio.duration) * 100;
        seekProgress.style.width = percent + '%';
        seekTrack.setAttribute('aria-valuenow', String(Math.round(percent)));
    }

    function refreshDuration() {
        updateTimeDisplay();
        updateProgress();
    }

    function seekFromClientX(clientX) {
        if (!Number.isFinite(audio.duration) || audio.duration <= 0) {
            return;
        }

        var rect = seekTrack.getBoundingClientRect();
        var percent = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
        audio.currentTime = percent * audio.duration;
        seekProgress.style.width = (percent * 100) + '%';
        updateTimeDisplay();
    }

    function togglePlayPause() {
        if (isPlaying) {
            audio.pause();
            return;
        }

        var playPromise = audio.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function() {});
        }
    }

    function playAudio() {
        if (!audio.paused && !audio.ended) {
            return;
        }

        if (audio.ended) {
            audio.currentTime = 0;
        }

        var playPromise = audio.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function() {});
        }
    }

    playBtn.addEventListener('click', togglePlayPause);

    playBtn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            togglePlayPause();
        }
    });

    volumeBtn.addEventListener('click', function() {
        audio.muted = !audio.muted;
        updateVolumeState();
    });

    downloadBtn.addEventListener('click', function() {
        if (!audioSrc) return;
        var link = document.createElement('a');
        link.href = audioSrc;
        link.download = '';
        link.rel = 'noopener';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    });

    seekTrack.addEventListener('click', function(e) {
        seekFromClientX(e.clientX);
    });

    seekTrack.addEventListener('keydown', function(e) {
        if (!Number.isFinite(audio.duration) || audio.duration <= 0) {
            return;
        }

        var step = audio.duration * 0.05;
        if (e.key === 'ArrowRight') {
            e.preventDefault();
            audio.currentTime = Math.min(audio.duration, audio.currentTime + step);
        } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            audio.currentTime = Math.max(0, audio.currentTime - step);
        }
    });

    var onSeekMove = function(e) {
        if (!isSeeking) return;
        seekFromClientX(e.clientX);
    };

    var onSeekEnd = function() {
        isSeeking = false;
        document.removeEventListener('mousemove', onSeekMove);
        document.removeEventListener('mouseup', onSeekEnd);
    };

    seekTrack.addEventListener('mousedown', function(e) {
        isSeeking = true;
        seekFromClientX(e.clientX);
        document.addEventListener('mousemove', onSeekMove);
        document.addEventListener('mouseup', onSeekEnd);
    });

    seekTrack.addEventListener('touchstart', function(e) {
        isSeeking = true;
        if (e.touches[0]) {
            seekFromClientX(e.touches[0].clientX);
        }
    }, { passive: true });

    seekTrack.addEventListener('touchmove', function(e) {
        if (!isSeeking || !e.touches[0]) return;
        seekFromClientX(e.touches[0].clientX);
    }, { passive: true });

    seekTrack.addEventListener('touchend', function() {
        isSeeking = false;
    });

    audio.addEventListener('play', function() {
        isPlaying = true;
        updateButtonState();
    });

    audio.addEventListener('pause', function() {
        isPlaying = false;
        updateButtonState();
    });

    audio.addEventListener('ended', function() {
        isPlaying = false;
        updateButtonState();
        updateProgress();
    });

    audio.addEventListener('loadedmetadata', refreshDuration);
    audio.addEventListener('durationchange', refreshDuration);
    audio.addEventListener('loadeddata', refreshDuration);
    audio.addEventListener('canplay', refreshDuration);
    audio.addEventListener('timeupdate', updateProgress);

    audio.preload = 'metadata';
    if (audio.readyState < HTMLMediaElement.HAVE_METADATA) {
        audio.load();
    } else {
        refreshDuration();
    }

    updateVolumeState();

    return {
        audio: audio,
        play: playAudio
    };
}

function initAudioToggle(playerApi) {
    var audioToggle = document.querySelector('.js-audio-toggle');
    if (!audioToggle || !playerApi) return;

    audioToggle.addEventListener('click', function() {
        var podcastSection = document.getElementById('podcast');

        if (podcastSection) {
            var header = document.querySelector('header');
            var headerHeight = header ? header.offsetHeight : 120;
            window.scrollTo({
                top: podcastSection.offsetTop - headerHeight - 30,
                behavior: 'smooth'
            });
        }

        setTimeout(function() {
            if (playerApi.audio.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
                playerApi.play();
                return;
            }

            playerApi.audio.addEventListener('canplay', function() {
                playerApi.play();
            }, { once: true });

            if (playerApi.audio.readyState < HTMLMediaElement.HAVE_METADATA) {
                playerApi.audio.load();
            }
        }, 300);
    });
}

export function initBlogFeatures() {
    initReadingProgress();
    initBlogTOC();

    var playerApi = initCustomAudioPlayer();
    initAudioToggle(playerApi);
}
